import React, { useEffect, useState } from 'react';
import {
  Typography,
  Box,
  Paper,
  TextField,
  Button,
  Switch,
  FormControlLabel,
  Alert,
} from '@mui/material';
import api from '../api/client';

const VersionPage = () => {
  const [data, setData] = useState({
    minVersion: '',
    latestVersion: '',
    forceUpdate: false,
    storeUrlAndroid: '',
    storeUrlIos: '',
  });
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    fetchVersion();
  }, []);

  const fetchVersion = async () => {
    try {
      const res = await api.get('/version');
      if (res.data.success && res.data.data) {
        const d = res.data.data;
        setData({
          minVersion: d.minVersion || '',
          latestVersion: d.latestVersion || '',
          forceUpdate: d.forceUpdate || false,
          storeUrlAndroid: d.storeUrlAndroid || '',
          storeUrlIos: d.storeUrlIos || '',
        });
      }
    } catch (err) {
      console.error('버전 조회 실패:', err);
    }
  };

  const handleSave = async () => {
    setLoading(true);
    setMsg(null);
    try {
      await api.post('/version/update', data);
      setMsg({ type: 'success', text: '저장 완료!' });
    } catch (err) {
      setMsg({ type: 'error', text: '저장 실패' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Typography variant="h5" fontWeight={700} sx={{ mb: 3 }}>
        앱 버전 관리
      </Typography>

      <Paper sx={{ p: { xs: 2, sm: 3 }, maxWidth: 600, width: "100%" }} variant="outlined">
        <Typography variant="h6" sx={{ mb: 2 }}>버전 설정 (Android / iOS 공통)</Typography>

        {msg && <Alert severity={msg.type} sx={{ mb: 2 }}>{msg.text}</Alert>}

        <TextField
          fullWidth
          label="최소 지원 버전"
          value={data.minVersion}
          onChange={(e) => setData({ ...data, minVersion: e.target.value })}
          placeholder="예: 1.0.0"
          helperText="이 버전 미만은 강제 업데이트 대상"
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth
          label="최신 버전"
          value={data.latestVersion}
          onChange={(e) => setData({ ...data, latestVersion: e.target.value })}
          placeholder="예: 1.1.0"
          sx={{ mb: 2 }}
        />
        <FormControlLabel
          control={
            <Switch
              checked={data.forceUpdate}
              onChange={(e) => setData({ ...data, forceUpdate: e.target.checked })}
              color="error"
            />
          }
          label="전체 강제 업데이트"
          sx={{ mb: 2, display: 'block' }}
        />
        <TextField
          fullWidth
          label="Google Play URL"
          value={data.storeUrlAndroid}
          onChange={(e) => setData({ ...data, storeUrlAndroid: e.target.value })}
          placeholder="https://play.google.com/..."
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth
          label="App Store URL"
          value={data.storeUrlIos}
          onChange={(e) => setData({ ...data, storeUrlIos: e.target.value })}
          placeholder="https://apps.apple.com/..."
          sx={{ mb: 3 }}
        />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button variant="contained" onClick={handleSave} disabled={loading}>
            {loading ? '저장 중...' : '저장'}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default VersionPage;
